import React from 'react';
import PropTypes from 'prop-types';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import FeesTable from 'patterns/FeesTable/FeesTable';

const FEES = [
  'MAINTENANCE',
  'TED',
  'DEPOSIT',
  'DEBIT',
  'WITHDRAW',
];

function SectionFees({ index }) {
  return (
    <Box
      tag="section"
      paddingBottom={{ xs: '20x', md: '24x', lg: '32x' }}
      paddingTop={{ xs: '16x', md: '20x', lg: '32x' }}
      paddingHorizontal={{ xs: '6x', md: '12x', lg: 56 }}
      display={{ lg: 'grid' }}
      gridTemplateColumns={{ lg: 'repeat(12,1fr)' }}
      gridColumnGap={{ lg: '8x' }}
    >
      <Box gridColumn={{ lg: '2 / span 7' }}>
        <Typography
          variant="title"
          intlKey={`cms.accountPage.cardsArea[${index}].title`}
          marginBottom={{ xs: '4x', md: '6x' }}
        />
        <Typography
          variant="subtitle"
          intlKey={`cms.accountPage.cardsArea[${index}].description`}
          marginBottom={{ xs: '16x', lg: '24x' }}
        />
        <Typography
          variant="title"
          intlKey={`cms.accountPage.cardsArea[${index}].tableTitle`}
          marginBottom={{ xs: '12x', md: '16x' }}
        />
      </Box>
      <Box gridColumn={{ lg: '2 / span 10' }}>
        <FeesTable feesList={FEES} />
      </Box>
    </Box>
  );
}

SectionFees.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionFees);
